import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialTypography from "../components/MaterialTypography";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialBox from "../components/MaterialBox";
import { createContext, useContext, useEffect, useState } from "react";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "./Utils/Baseurl";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import CancelIcon from "@mui/icons-material/Cancel";
import { DesignationContext } from "../context/designationcontext";
import { useUserDetails } from "../context/auth";

const PermissionTable = () => {
  const { handleClearSelection } = useContext(DesignationContext);
  const { AccessData } = useUserDetails();
  const teamleader = JSON.parse(sessionStorage.getItem("user"));
const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const { designation, setDesignation } = useContext(DesignationContext);
 const [tabValue, setTabValue] = useState("Employee");
  const encodedid = btoa(teamleader.id);

  const [value, setValue] = useState("My List");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const cancelpermission = `
    
      mutation CancelPermission($permissionId: ID!) {
  CancelPermission(permissionId: $permissionId) {
    success
  }
}
    
    `;

  const cancelpermissionmethod = async (id) => {
    try {
      const res = await axios.post(
        BASEURL,
        {
          query: cancelpermission,
          variables: {
            permissionId: id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const [tabledata, settabledate] = useState([]);

  useEffect(() => {
    getteamleadeID();
  }, []);

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      firstName
      lastName

    }
  }
}
`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == teamleader.empid
      );
      setTeamLeaderID(filterdata);

    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({
      //   ...pageState,
      //   loading: false,
      //   error: true,
      //   message: error.message,
      // });
    }
  };


  const handleSetTabValue = (event, newValue) => {
    if (newValue == "HR") {
      // setHRreqularzation(true);
    } else if (newValue == "Manager") {
      // setMangerApproval(true);
    }
    setTabValue(newValue);
  };


  useEffect(() => {
    handleClearSelection();

    if (value == "My List") {
      const query = `
    
           query PermissionsByUser($userId: ID!) {
  permissionsByUser(userId: $userId) {
    id
    user {
      username
      id
      firstName
      lastName
      teamleader
    }
    permissionOn
    permissionFrom
    permissionTill
    reason
    balanceHours
    hrApproval
    teamApproval
    status
    createdAt
  }
}
                
                
                
                `;
      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
              variables: {
                userId: "VXNlck5vZGU6" + "" + encodedid,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          settabledate(res.data.data.permissionsByUser);
        } catch (error) {
          console.error(error);
          settabledate([]);
        }
      };

      fetchpermission();
    }

    if (value == "HR List") {

      const query = `
    
        query All_permissions{
  permissions {
    id
    user {
      id
      username  
    }
    permissionOn
    permissionFrom
    permissionTill
    reason
    balanceHours
    teamApproval
    hrApproval
    status
    createdAt
  }
}
              
              
              
              `;

      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          settabledate(res.data.data.permissions);
        } catch (error) {
          console.error(error);
          settabledate([]);
        }
      };

      fetchpermission();
    }
    if (value == "Team List") {

      const query = `
    
     query PermissionsByTeamleader($teamleaderId: ID!) {
  permissionsByTeamleader(teamleaderId: $teamleaderId) {
    id
    user {
      id
      username
      firstName
      lastName
    }
    permissionOn
    permissionFrom
    permissionTill
    status
    createdAt
  }
}
              
              
              `;


      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
              variables: {
                teamleaderId: TeamLeaderID[0]?.user?.id,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          settabledate(res.data.data.permissionsByTeamleader);
        } catch (error) {
          console.error(error);
          settabledate([]);
        }
      };

      fetchpermission();
    }
  }, [value]);
  const nav = useNavigate();

  const Permission = {
    columns: [
    value=="My List"? {
        field: "cancelpermission",
        headerName: "Cancel Permission",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
        filter: false,
      }:"",

      {
        field: "username",
        headerName: "Username",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },

      {
        field: "status",
        headerName: "Permission Status",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },

      {
        field: "permissionOn",
        headerName: "Permission On",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
        filter: true,
      },
      {
        field: "permissionFrom",
        headerName: "PermissionFrom",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },
      {
        field: "permissionTill",
        headerName: "PermissionTill",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },


      // {
      //   field: "responsiblePerson",
      //   headerName: "Responsible Person",
      //   width: 200,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "teamApproval",
        headerName: "TeamApproval",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },
      {
        field: "hrApproval",
        headerName: "HrApproval",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },

      {
        field: "createdAt",
        headerName: "createdAt",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },
    ],

    rows: tabledata?.map((permission) => ({
      id: permission?.id,
      cancelpermission: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            top: "10px",
          }}
        >
          <CancelIcon
            onClick={(event) => {
              event.stopPropagation(); // Prevent row click event
              cancelpermissionmethod(permission.id);
            }}
            sx={{
              fontSize: "100px",
              width: 28,
              height: 30,
              transition: `transform 0.2s ease-in-out`,

              "&:hover": {
                transform: "translateY(-8px)",
                transition: `transform 0.2s ease-in-out`,
              },
            }}
          />
        </div>
      ),
      username:permission.user.username,
      permissionOn: permission.permissionOn,
      permissionFrom: permission.permissionFrom,
      permissionTill: permission.permissionTill,
      teamApproval: permission.teamApproval,
      hrApproval: permission.hrApproval,
      status: permission.status,
      createdAt: permission.createdAt,
    })),
  };


  const onRowClick = (e) => {
    if (e?.id) {
      if (value == "My List") {
        nav(`/permission/requestpermission?id=${e?.id}`);
      } else {
        setDesignation({
          value: value,
        });

        nav(`/permission/approve?id=${e?.id}`);
      }
    }
  };

  const handleclick = () => {
    nav("/permission/requestpermission");
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Permission
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>

                {/* //Appbar */}
                <MaterialBox alignItems="center" width="60%">
                  <MaterialBox width="80%">
                    <div style={{ position: "relative", left: "20px" }}>
                      <AppBar position="static">
                        {/* <Tabs
                          orientation="horizontal"
                          value={value}
                          onChange={handleChange}
                        >
                          <Tab label="HR List" value="HR List" />
                          <Tab label="Team List" value="Team List" />
                          <Tab label="My List" value="My List" />
                        </Tabs> */}
                        <Tabs
                          orientation={tabsOrientation}
                          value={value}
                          onChange={handleChange}
                          sx={{ backgroundColor: "transparent" }}
                        >
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "HrApproval" &&
                                item.can_access
                            ) && <Tab label="HR List" value="HR List" />}
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                (item.component === "HrApproval" || item.component === "ManagerApproval") &&
                                item.can_access
                            ) && <Tab label="Team List" value="Team List" />}
                          <Tab label="My List" value="My List" />
                        </Tabs>
                      </AppBar>
                    </div>
                  </MaterialBox>
                </MaterialBox>

                <Stack alignItems="" lineHeight={1}>
                {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddPermission" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleclick}
                  >
                    Request Permissiom
                  </MaterialButton>
                      )}
                </Stack>
          
              </Stack>

              <Stack
                direction="row"
                //   justifyContent="space-between"
                //   alignItems="center"
                marginTop={0}
                spacing={0}
              >
                <Stack>
                  {/* <MaterialSelect
      name="status"
      value={Status} // Set the selected value here
      customStyles={{ optionPadding: 20 }}
      onChange={handlechange}
      options={Departmentnames.depatmentdate.map((value) => ({
        value: value.id,
        label: value.departmentName,
      }))}
      error={false}
      // success={true}
      // isClearable
    /> */}
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={Permission.rows}
          columns={Permission.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={""}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Permission request found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Permission request details. Click on
                  the "Request Permission" button to start adding Permission
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default PermissionTable;
